import { useContext } from 'react'
import { CalendarContext } from '../components/calendar-provider'

export const useCalendar = () => useContext(CalendarContext)
